const mbtiCognitiveFunctions = {
  INTJ: {
    Primary: "Ni",
    Auxiliary: "Te",
    Tertiary: "Fi",
    Inferior: "Se",
  },
  INFJ: {
    Primary: "Ni",
    Auxiliary: "Fe",
    Tertiary: "Ti",
    Inferior: "Se",
  },
  ENTJ: {
    Primary: "Te",
    Auxiliary: "Ni",
    Tertiary: "Se",
    Inferior: "Fi",
  },
  ENFJ: {
    Primary: "Fe",
    Auxiliary: "Ni",
    Tertiary: "Te",
    Inferior: "Si",
  },
  INTP: {
    Primary: "Ti",
    Auxiliary: "Ne",
    Tertiary: "Si",
    Inferior: "Fe",
  },
  INFP: {
    Primary: "Fi",
    Auxiliary: "Ne",
    Tertiary: "Ti",
    Inferior: "Se",
  },
  ENTP: {
    Primary: "Ne",
    Auxiliary: "Ti",
    Tertiary: "Fe",
    Inferior: "Si",
  },
  ENFP: {
    Primary: "Ne",
    Auxiliary: "Fi",
    Tertiary: "Te",
    Inferior: "Si",
  },
  ISTJ: {
    Primary: "Si",
    Auxiliary: "Te",
    Tertiary: "Fi",
    Inferior: "Ne",
  },
  ISFJ: {
    Primary: "Si",
    Auxiliary: "Fe",
    Tertiary: "Ti",
    Inferior: "Ne",
  },
  ESTJ: {
    Primary: "Te",
    Auxiliary: "Si",
    Tertiary: "Ne",
    Inferior: "Fi",
  },
  ESFJ: {
    Primary: "Fe",
    Auxiliary: "Si",
    Tertiary: "Te",
    Inferior: "Ni",
  },
  ISTP: {
    Primary: "Ti",
    Auxiliary: "Se",
    Tertiary: "Ni",
    Inferior: "Fe",
  },
  ISFP: {
    Primary: "Fi",
    Auxiliary: "Se",
    Tertiary: "Ti",
    Inferior: "Ne",
  },
  ESTP: {
    Primary: "Se",
    Auxiliary: "Ti",
    Tertiary: "Fe",
    Inferior: "Ni",
  },
  ESFP: {
    Primary: "Se",
    Auxiliary: "Fi",
    Tertiary: "Te",
    Inferior: "Ni",
  },
};

export default mbtiCognitiveFunctions;
